export default "__VITE_ASSET__D8vl6uPK__"